import { render, staticRenderFns } from "./ticket-chart.vue?vue&type=template&id=593ee35f"
import script from "./ticket-chart.vue?vue&type=script&lang=js"
export * from "./ticket-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports